import { Navigate, NavigateProps, useLocation } from "react-router-dom";
import { buildRedirectUrl } from "../../utilities/location";

export default function Redirect(props: NavigateProps) {
    const location = useLocation();
    const { to, ...rest } = props;

    const destination = buildRedirectUrl(to as string, { location });

    return <Navigate to={destination} {...rest} />;
}